/**
 * 用户相关
 */
import $config from '@/config/index';
import { setLocalStorage, getLocalStorage, removeLocalStorage } from '@/common/js/mUtils';
import userModel from '@/libs/userModel';
import {
  getUserPermission,
  getUserInfo,
  login,
  loginByOA,
  tokenCovert
} from '@/api/index';
const localUser = getLocalStorage('user') || {};
const state = {
  isLogined: false,
  oauth:  localUser.oauth || {},
  permissionsList: localUser.permissionsList || [],
  userData: localUser.userData || {},
  // 用于缓存子系统token
  cacheToken: {},
};

const actions = {
  /**
   * 登陆操作
   * */
  doLogin({ commit, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      login(formData)
        .then(res => {
          commit('UPDATE_OAUTH', res.body);
          // 获取权限
          dispatch('getUserPermission')
            .then(r => {
              resolve(res.body, r);
            })
            .catch(err => {
              reject(err);
            });

          // 获取用户信息
          dispatch('getUserInfo');
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  doLoginByTicket({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      // 验证成功
      loginByOA(params)
        .then(res => {
          commit('UPDATE_OAUTH', res.body); // 获取权限
          dispatch('getUserPermission')
            .then(r => {
              resolve(res.body, r);
            })
            .catch(err => {
              reject(err);
            });

          // 获取用户信息
          dispatch('getUserInfo');
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  doLoginByToken({ commit, dispatch }, token) {
    return new Promise((resolve, reject) => {
      // 验证成功
      login({
        grant_type: 'refresh_token',
        refresh_token: token
      })
        .then(res => {
          commit('UPDATE_OAUTH', res.body);
          dispatch('getUserPermission')
            .then(r => {
              resolve(res.body, r);
            })
            .catch(err => {
              reject(err);
            });

          // 获取用户信息
          dispatch('getUserInfo');
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /**
   * 获取个人信息
   * @param commit
   */
  async getUserInfo({ commit }) {
    // 验证成功
    // getUserInfo().then(res => {
    //   commit('UPDATE_USERDATA', res.body);
    // });
    let res = await getUserInfo()
    commit('UPDATE_USERDATA', res.body);
    return res.body
  },
  /**
   * 重新获取token, 刷新用户登录信息
   *  切换令牌
   */
  refreshTokenByClientId({ commit, }, clientId) {
    return new Promise((resolve, reject) => {
      tokenCovert(clientId)
      .then(res => {
        commit('UPDATE_USER_TOKEN', { id: clientId, data: res.body });
        console.log('tocken刷新');
        resolve(res.body);
      })
      .catch(err => {
        reject(err)
      });
    })
  },
  /**
   *  获取个人权限
   */
  getUserPermission({ commit }) {
    return new Promise((resolve, reject) => {
      getUserPermission()
        .then(res => {
          commit('UPDATE_USER_PERMISSION', res.body);
          resolve(res.body);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /**
   * 退出登录
   */
  doLogout() {
    // 跳转用户中心退出登录页
    userModel._goLogoutRedirectToUserCenter();
  },

  /**
   * 清除用户登录信息
   */
  clearUserAuthInfo({ commit }) {
    commit('UPDATE_OAUTH', {});
    commit('CLEAR_USER_CACHE_TOKEN');
    commit('UPDATE_USER_PERMISSION');
    commit('UPDATE_USERDATA', {});
  },
};

const mutations = {
  /**
   * 更新登录状态
   * @param state
   * @param b
   * @constructor
   */
   UPDATE_LOGIN_STATE(state, b) {
    state.isLogined = !!b;
    // 存储状态
    mutations['SAVE_USER_TO_LOCAL'](state);
  },
  /**
   * 更新oauth相关
   */
  UPDATE_USERDATA(state, data) {
    state.userData = {
      ...data
    };
    // 存储状态
    mutations['SAVE_USER_TO_LOCAL'](state);
  },

  /**
   * 更新oauth相关
   */
  UPDATE_OAUTH(state, data) {
    state.oauth = { ...data };
    // console.log(state.oauth);
    // console.log('UPDATE_OAUTH', state);
    // 存储状态
    mutations['SAVE_USER_TO_LOCAL'](state);
  },
  /**
   *刷新用户token，并缓存起来
   * @param state
   * @param datta
   * @constructor
   */
  UPDATE_USER_TOKEN(state, data) {
    // console.log('UPDATE_USER_TOKEN', data);
    if (!data) return;
    // if (!state.cacheToken) state.cacheToken = {};
    // state.cacheToken[data.id] = data.data;
    // 存储状态
    mutations['UPDATE_OAUTH'](state, data.data);
  },
  /**
   * 清除用户缓存的token
   * @param state
   * @constructor
   */
  CLEAR_USER_CACHE_TOKEN(state) {
    state.cacheToken = {};
    localStorage.removeItem('user');
    localStorage.removeItem('_localQueryCodeAdminBase');
    // 存储状态
    mutations['SAVE_USER_TO_LOCAL'](state);
  },
  /**
   * 将user state 数据存储在localstore里面
   */
  SAVE_USER_TO_LOCAL(state) {
    if (JSON.stringify(state) === '{}') {
      removeLocalStorage('user');
      return;
    }
    const localUser = getLocalStorage('user') || {};
    // 合并更新数据
    const payload = {
      ...localUser,
      ...state,
    }
    setLocalStorage('user', payload);
  },
  /**
   * 从localstorage里取出数据更新user state
   */
  UPDATE_USER_FROM_LOCAL(state) {
    let user = getLocalStorage('user');
    if (user) {
      for (let key in state) {
        state[key] = user[key];
      }
    }
  },
  /**
   * 更新个人权限相关
   * @param state
   * @param data
   */
  UPDATE_USER_PERMISSION(state, data) {
    state.permissionsList = data || [];
    // 存储状态
    mutations['SAVE_USER_TO_LOCAL'](state);
  },
};

const getters = {
  authorization(state) {
    return state.oauth.access_token
      ? 'Bearer ' + state.oauth.access_token
      : $config.defaultAuthorization;
  },
  userData(state) {
    return state.userData;
  },
  oauth(state) {
    return state.oauth;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
